import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import { LoginModalComponent } from '../../modals/login-modal/login-modal.component';
import { SettingsService } from '../../services';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ContactService } from '../../services/contact.service';

@Component({
  selector: 'app-app-store',
  templateUrl: './app-store.component.html',
  styleUrls: ['./app-store.component.scss'],
  providers: [
    { provide: OverlayContainer, useClass: OverlayContainer }
  ]
})
export class AppStoreComponent {
  contactForm: FormGroup;
  copyrightYear: number;
  isApple: boolean;
  isAndroid: boolean;

  constructor(public settings: SettingsService, private modalCtrl: ModalController, private fb: FormBuilder, private snackBar: MatSnackBar, private contactService: ContactService) { 
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required]
    });

    this.copyrightYear = new Date().getFullYear();
    
    // Detect if the user is on a mobile device
    this.isApple = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    this.isAndroid = /Android/i.test(navigator.userAgent);
  }

  submitForm() {
    if (this.contactForm.valid) {
      this.contactService.sendContactForm(this.contactForm.value).subscribe({
        next: (response) => {
          this.showNotification('Form successfully submitted.');
          this.contactForm.reset();
        },
        error: (error) => {
          this.showNotification('Error sending message.');
        }
      });
    } else {
      this.showNotification('Please fill out the form completely.');
    }
  }

  showNotification(message: string, action: string = 'Close') {
    this.snackBar.open(message, action, {
      duration: 3000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

  async openLoginModal() {
    const modal = await this.modalCtrl.create({
        component: LoginModalComponent,
        cssClass: 'login-modal',
        backdropDismiss: false,
        keyboardClose: false
    });

    await modal.present();
    await modal.onDidDismiss();
  }
}
